"use client";

import {
  ButtonBase,
  buttonStyleVars,
} from "@faire/slate/private/button/ButtonBase";
import { useHandleKeyDown } from "@faire/slate/private/hooks/useHandleKeyDown";
import { cn } from "@faire/web/tools/cn";
import React, { useRef } from "react";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
  onEscape?: () => void;
}

export const ToastCtaButton: React.FC<React.PropsWithChildren<IProps>> = ({
  children,
  className,
  onEscape,
  ...props
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const style = buttonStyleVars({
    color: "var(--fs-toast-text-color)",
    hoverColor: "var(--fs-toast-text-color)",
    activeColor: "var(--fs-toast-text-color)",
  });

  useHandleKeyDown({
    Escape: onEscape,
  });

  return (
    <ButtonBase
      className={cn("underline", className)}
      {...props}
      style={style}
      ref={buttonRef}
    >
      {children}
    </ButtonBase>
  );
};
